export default class SocketProtocol {
  static CONNECTION = "connection";
  static JOIN_ROOM = "JOIN_ROOM";
  static LEAVE_ROOM = "LEAVE_ROOM";
  static CREATE_ROOM = "CREATE_ROOM";
  static ROOM_LIST = "ROOM_LIST";
  static CHAT = "CHAT";
  static USER_LIST = "USER_LIST";
  static START_GAME = "START_GAME";
  static CHANGE_PLAYER_STATE = "CHANGE_PLAYER_STATE";
  static ADD_AI_PLAYER = "ADD_AI_PLAYER";
  static ROOM_STATE = "ROOM_STATE";
  static RECONNECT_TO_GAME = "RECONNECT_TO_GAME";
  static SKIP_VOTE = "SKIP_VOTE";

  // Reconnection
  static REQUEST_GAME_STATE = "REQUEST_GAME_STATE";
  static INTENTIONAL_LEAVE = "INTENTIONAL_LEAVE";

  // Private Chat
  static LATEST_INDEX = "LATEST_INDEX";
  static REQUEST_CHAT_HISTORY = "REQUEST_CHAT_HISTORY";
  static CHAT_HISTORY = "CHAT_HISTORY";
}
